<template>
    <div class="package_history_item">
        <span>
            {{package_response.is_setting_is_package_mode
                ? $t('ui.scanner.package.package')
                : $t('ui.scanner.package.unpackage')
            }}
        </span>
        <span v-if="package_response.status == 'success'" style="color: green;">
            <!-- 成功 -->
            {{ $t('ui.general.success') }}
        </span>
        <span v-if="package_response.status == 'failure'" style="color: red;">
            <!-- 失敗 -->
            {{ $t('ui.general.failure') }}
        </span>

        {{ package_response.parent_core_waybill.number }}
        [{{package_response.parent_core_waybill.material.name}}]
        <span v-if="package_response.is_setting_is_package_mode">
            　
            <!-- {{ package_response.parent_core_waybill.child_core_waybills.length }}件 -->
            {{
                $t('ui.scanner.package.total__number',{
                    number: package_response.parent_core_waybill.child_core_waybills.length
                })
            }}
        </span>

        <span style="font-size:small;font-weight: bold;"
            class="pointer"
            v-if="package_response.is_setting_is_package_mode"
            @click="is_show_detail = !is_show_detail">
            [{{ !is_show_detail
                ? $t('ui.scanner.package.detail')
                : $t('ui.scanner.package.hide')
            }}]
        </span>

        <div class="current_package_response" v-if="is_show_detail">
            <div style="padding: 6px;"
                class="goods"
                v-if="package_response.parent_core_waybill.child_core_waybills.length">
                <span v-for="core_waybill in package_response.parent_core_waybill.child_core_waybills">
                    {{ core_waybill.number }}
                    <span class="material_name"
                        v-if="core_waybill.material">
                        [{{ core_waybill.material.name }}]
                    </span>
                    /
                </span>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    components: {
    },
    props: {
        package_response: {
            default: {},
            type: Object
        },
    },
    data() {
        return {
            is_show_detail: false,
        }
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },

}
</script>

<style lang="scss" scoped>
    .goods {
        border: 3px white solid;
    }
    .current_package_response {
        max-height: 90px;
        overflow: auto;
        padding: 0 12px;
        padding-top: 3px;
    }


</style>
